import { render, staticRenderFns } from "./GuitarNeck.vue?vue&type=template&id=31d783e5&scoped=true&"
import script from "./GuitarNeck.vue?vue&type=script&lang=js&"
export * from "./GuitarNeck.vue?vue&type=script&lang=js&"
import style0 from "./GuitarNeck.vue?vue&type=style&index=0&id=31d783e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d783e5",
  null
  
)

export default component.exports